import React from 'react';
import classNames from 'components/Toasts/toast.module.css';

const TextPopup = (props) => {
  const {onClosePopup, hasButton, onUndoClick, selectedId, title} = props;

  React.useEffect(() => {
    const to = setTimeout(() => {
      onClosePopup();
    }, 3000);
    return () => {
      clearTimeout(to);
    };
  }, []);

  return (
    <div className="d-flex justify-content-center flex-row ">
      <div
        className={
          'd-flex justify-content-between align-items-center ' +
          classNames['textPopup']
        }
      >
        <div className={classNames['leftWrapper']}>
          <div className={classNames['iconWrapper']}>
            <i className={classNames['check'] + ' ' + classNames['icon']}></i>
          </div>
          <p className={classNames['message']}>
            {title && typeof title == 'string' ? title : JSON.stringify(title)}
          </p>
        </div>
        <div className={classNames['rightWrapper']}>
          {hasButton && (
            <button
              className={classNames['undo']}
              onClick={() => onUndoClick(selectedId)}
            >
              Undo
            </button>
          )}
          <i
            className={classNames['close'] + ' ' + classNames['icon']}
            onClick={onClosePopup}
          ></i>
        </div>
      </div>
    </div>
  );
};

export default TextPopup;
